<template>
  <div>
    <Breadcrumbs></Breadcrumbs>
    <div class="product-list market-place-product-list">
      <div class="product-list-bg"></div>
      <SessionContent></SessionContent>
      <b-card-group class="centered-block align-items-stretch d-flex flex-row flex-wrap" deck v-if="campaignProducts.length">
        <ProductTile v-for="campaignProduct in campaignProducts"
                     :key="'product-' + campaignProduct.id"
                     :product="campaignProduct">
        </ProductTile>
      </b-card-group>
      <div v-else>
        <div class="centered-block">
          <div class="step-title">No products found</div>
        </div>
      </div>
    </div>
    <b-row class="justify-content-center boxes welcome">
      <b-col v-if="session && session.can_undo" sm="8" md="4" lg="3">
        <button type="button" @click="goBack()" class="btn-base input-choice-btn new-btn-outline-success stroke-2x">Back</button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
import {InputType} from '../constants/index'
import ProductTile from './ProductTile'
import SessionContent from './SessionContent'
import Breadcrumbs from './Breadcrumbs'
import {stopMouseflowRecording} from '@/utils'

export default {
  name: 'Products',
  components: {Breadcrumbs, SessionContent, ProductTile},
  props: {
    input: Object,
    title: String,
    subtitle: String,
    submit: {
      type: Function
    }
  },
  data: function() {
    return {
      campaignProducts: []
    }
  },
  computed: {
    ...mapState(['session'])
  },
  methods: {
    jumpAndGetProducts: function() {
      this.$store.commit('busy')
      this.$store.dispatch('jump', {step: 'product info'})
        .then(() => {
          console.log('Jumped to step products')
          this.getCampaignProducts()
        })
        .catch(err => {
          this.$store.commit('ready')
          this.$store.commit('critical_error', err)
        })
    },
    initProducts: function() {
      if (!this.session) { // If user directly lands on this page, then create session first
        this.$store.dispatch('start').then(_response => this.jumpAndGetProducts())
      } else if (this.session.step_type !== InputType.Product) {
        this.jumpAndGetProducts()
      } else {
        this.getCampaignProducts()
      }
    },
    getCampaignProducts: function() {
      axios.get('/campaign_products/info/', {
        params: {
          is_deleted: false
        }
      }).then(result => {
        console.log(result)
        this.campaignProducts = result.data.results
        this.$store.commit('ready')
      }, error => {
        console.log(error)
        this.$store.commit('critical_error', error)
        this.$store.commit('ready')
      })
    },
    done: function() {
      this.submit(this.input)
    },
    goBack: function() {
      this.$store.commit('busy')
      this.$store.dispatch('undo')
        .then(session => {
          this.$store.commit('clear_messages')
          this.$store.commit('increment_undo_count')
          this.$router.replace({name: 'session'})
        })
        .catch(err => {
          console.log(err)
          if (!err.response || err.response.status !== 422) {
            this.$store.commit('critical_error', err)
          }
        })
    }
  },
  created() {
    this.$store.commit('busy')
    this.initProducts()
    stopMouseflowRecording()
  }
}
</script>

<style lang="less">
  .product-list-bg {
    position: absolute;
    left: 0;
    bottom: -50px;
    width: 100%;
    height: 100%;
  }

  .market-place-product-list {
    .centered-block {
      margin-left: 0.5rem;
    }

    .card {
      border: none;
      margin-left: 0;
      margin-right: 0;
      max-width: 43% !important;
      margin-bottom: 20px !important;
      box-shadow: 0 16px 40px #1a1a1a1a;
      display: flex;
      justify-content: flex-start;

      .card-body {
        padding: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .product-tile-image {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 150px;
          img {
            max-width: 130px;
          }
        }

        .mg {
          font-size: 14px;
        }
        .price {
          color: #333333;
          font-family: var(--font_family);
          font-weight: 400;
          .product-price {
            font-size: 14px;
            font-weight: 450;
          }
          .original-price {
            font-size: 14px;
            color: #333333;
          }
          .sale-price {
            font-size: 15px;
            color: var(--theme_color);
          }
          .membership-price {
            font-size: 14px;
          }
          .membership-price-tag {
            font-size: 12px;
          }
        }
        .product-name {
          color: #333333;
          font: normal normal 700 18px/23px Ubuntu;
          opacity: 1;
          padding: 0 0.8rem !important;
          line-height: 16px;
          text-transform: uppercase;
          text-align: center;
          flex: 1;
          font-size: 12px;
        }
        .buy-now-button {
          font-size: 11px;
          //font-size: 18px;
          font-weight: 700;
          border-radius: 0 0 0.25rem 0;
        }
      }

      img {
        width: 200px;
        margin: auto;
        border-radius: 0;
        border: none;
      }
    }

    .card-deck {
      -ms-flex-flow: row wrap;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      flex-flow: row wrap;
      margin-right: -15px;
      margin-left: -15px;
    }

    .new-onsale {
      width: 42px;
      height: 42px;
      top: 10px;
      right: 14px;
      font-size: 11px;
    }
  }

  @media only screen and (min-width: 321px) {
    .market-place-product-list {
      .card {
        .card-body {
          .product-name {
            font-size: 14px;
            line-height: 16px;
          }
          .product-tile-image {
            height: 150px;
            img {
              max-width: 130px;
            }
          }
          .buy-now-button {
            font-size: 13px;
          }
          .price {
            .product-price, .original-price, .sale-price, .membership-price {
              font-size: 16px;
            }
          }
        }
      }
    }
  }

  @media only screen and (min-width: 576px) {
    .market-place-product-list {
      .card {
        width: 250px !important;
        max-width: 256px !important;
        margin-left: 5px;
        margin-right: 5px;
        margin-bottom: 40px !important;

        .card-body {
          height: 100%;

          .product-tile-image {
            height: 220px;
            img {
              width: 200px;
              max-width: 400px;
              margin: auto;
              border-radius: 0;
              border: none;
            }
          }

          .product-name {
            font-size: 18px;
            padding: 0 0.7rem !important;
            line-height: 23.4px;
            font-weight: 700;
          }
          .buy-now-button {
            font-size: 16px;
          }
          .mg {
            font-size: 12px;
          }
          .price {

            .product-price {
              font-size: 22px;

            }
            .original-price {
              font-size: 16px;

            }
            .sale-price {
              font-size: 18px;
            }

            .membership-price-container {
              text-align: left;
            }
            .membership-price {
              font-size: 14px;
            }
            .membership-price-tag {
              font-size: 12px;
            }

          }
        }
      }
    }
  }

  @media only screen and (min-width: 769px) {
    .market-place-product-list {
      .card {
        width: 250px !important;
        max-width: 300px !important;
        &.product-tile {
          &-image {
            height: 220px;
          }
        }

        .product-tile-image {
          height: 220px;
          img {
            max-height: 220px;
          }
        }
        .card-body {
          height: 100%;
          .product-name {
            font-size: 18px;
            padding: 0 0.7rem !important;
          }
          .buy-now-button {
            font-size: 16px;
          }
          .mg {
            font-size: 12px;
          }
          .price {
            .product-price {
              font-size: 24px;

            }
            .original-price {
              font-size: 20px;
            }
            .sale-price {
              font-size: 28px;
            }
            .membership-price {
              font-size: 19px;
            }
            .membership-price-tag {
              font-size: 16px;
            }
          }
        }
      }
    }
  }

  @media only screen and (min-width: 1201px) {
    .market-place-product-list {
      .card {
        width: 250px !important;
        max-width: 300px !important;
      }
    }
  }
</style>
